import React from 'react';
import { Heading } from '..';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaPhoneAlt, FaEnvelope, FaVideo, FaCamera, FaRegFileAlt, FaBan, FaImages } from 'react-icons/fa';
import { IoLogoWhatsapp } from 'react-icons/io';
import { MdLiveTv } from 'react-icons/md';
import { FaRegCommentDots } from 'react-icons/fa6';

const updateDisplayData = {
  daily_report_card: {
    name: 'Daily Report Card',
    icon: <FaRegFileAlt />,
  },
  photos_videos: {
    name: 'Text / Photos / Videos',
    icon: (
      <>
        <FaImages />
      </>
    ),
  },
  call: {
    name: 'Phone Call',
    icon: <FaPhoneAlt />,
  },
  video_call: {
    name: 'Video Call',
    icon: <FaVideo />,
  },
  live_Feed: {
    name: 'Live Feed',
    icon: <MdLiveTv />,
  },
  no_updates: {
    name: 'No Updates',
    icon: <FaBan />,
  },
  whatsapp: {
    name: 'WhatsApp',
    icon: <IoLogoWhatsapp />,
  },
};

const SectionPreferredCommunicationMethod = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.cleaningFacilitiesList}>
        {selectedOptions.map(option => {
          const method = updateDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{method?.icon}</span>
              <span>{method?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionPreferredCommunicationMethod;
